/**
 * Fime – Back to Top button.
 *
 * Hidden by default; shown once the user scrolls down past a
 * threshold. Clicking smooth-scrolls to the top of the page.
 */

const backToTopBtn = document.getElementById('back-to-top');

if (backToTopBtn) {
        const SHOW_AFTER_PX = 400;

        window.addEventListener('scroll', function () {
                if (window.scrollY > SHOW_AFTER_PX) {
                        backToTopBtn.hidden = false;
                } else {
                        backToTopBtn.hidden = true;
                }
        });

        backToTopBtn.addEventListener('click', function () {
                window.scrollTo({ top: 0, behavior: 'smooth' });
        });
}
